import '@babel/polyfill'
import Vue from 'vue'
import './globals'
import './filters'
import './plugins/vuetify'
import './plugins/icons'
import './assets/site.scss'
import './components/mongo-datatable/style.scss'
import { store } from './store'
import GoogleAuth from './plugins/google-auth'
import router from './router'
import App from './App.vue'

Vue.config.productionTip = false

if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
  window.location.href = window.location.href.replace('http://', 'https://')
} else {
  GoogleAuth.load({
    client_id: process.env['VUE_APP_GOOGLE_CLIENT_ID']
  }).then(() => {
    /* eslint-disable no-new */
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app')
  })
}
